import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import {
  AbstractControl,
  ControlValueAccessor,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { IconService } from '../../../services/icon/icon.service';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-icon-dropdown',
  standalone: true,
  imports: [
    DropdownModule,
    ReactiveFormsModule,
    SharedModule,
    SvgIconComponent,
    FormsModule,
    FormFieldWrapperComponent,
    NgClass,
  ],
  templateUrl: './icon-dropdown.component.html',
  styleUrl: './icon-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IconDropdownComponent),
      multi: true,
    },
  ],
})
export class IconDropdownComponent implements ControlValueAccessor, OnInit {
  options: any[] = [];
  icon?: any;
  touched = false;
  disabled = false;

  @Input() label = '';
  @Input() name = 'icon';
  @Input() colSize: string | number = 12;
  @Input() formField: AbstractControl | null = null;
  @Input() mode: 'maki' | 'fa' = 'maki';
  @Output() selectionChange = new EventEmitter<string>();

  protected onChange = (value: string) => {
    this.selectionChange.emit(value);
  };
  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.icon = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectIcon(icon: any): void {
    this.icon = icon;
    this.onChange(icon);
    this.onTouched();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor(private iconService: IconService) {}

  ngOnInit() {
    console.log('this.mode', this.mode);
    if (this.mode === 'maki') {
      this.options = this.iconService.getIcons();
    } else {
      this.options = this.iconService.getThemeIcons();
    }
  }
}
